import type { SVGProps } from 'react';

const SvgPlusCircleFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path
      fill={props.color}
      d="M18 0C8.06 0 0 8.06 0 18s8.06 18 18 18 18-8.06 18-18S27.94 0 18 0Zm7.07 19.1h-5.99v5.95h-2.16V19.1h-6V17h6v-6h2.15v5.94h6v2.16Z"
      className="plus-circle-filled_svg__cls-1"
    />
  </svg>
);

export default SvgPlusCircleFilled;
